export default "__VITE_ASSET__BV_VAyMj__"